import React from "react";
import { useNavigate } from "react-router-dom";
import "./../styles/Portfolio.css";
import commerce from "../assets/images/ecommerce.webp";
// import portfolio from "../assets/images/portfolio.jpg";
import mobile from "../assets/images/fitnessapp.avif";
// import landing from "../assets/images/leanding.png";
// import taskManagement from "../assets/images/TaskManagement.jpg";
import ensoGlass from "../assets/images/enso.png";
import hrManagement from "../assets/images/Management.png";
import realEstate from "../assets/images/article.jpg";
import inventorySystem from "../assets/images/Inventory.jpg";

// const portfolioItems = [
//   {
//     id: 1,
//     title: 'E-Commerce Website',
//     image: commerce,
//     description: 'Built with React, Node.js, and MongoDB. Responsive and feature-rich.',
//     details: 'More details about the e-commerce project...',
//     link: 'https://admin.webcruxtechnology.com/login',
//   },
//   {
//     id: 2,
//     title: 'Portfolio Website',
//     image: portfolio,
//     description: 'A modern personal portfolio built using React and styled-components.',
//     details: 'More details about the portfolio project...',
//     link: 'https://admin.webcruxtechnology.com/login',
//   },
//   {
//     id: 3,
//     title: 'Mobile App UI',
//     image: mobile,
//     description: 'Cross-platform app UI designed with Figma and built in Flutter.',
//     details: 'More details about the mobile app...',
//     link: 'https://admin.webcruxtechnology.com/login',
//   },
//   {
//     id: 4,
//     title: 'Landing Page Design',
//     image: landing,
//     description: 'High-converting landing page with clean UX, built in HTML/CSS/JS.',
//     details: 'More details about the landing page...',
//     link: 'https://admin.webcruxtechnology.com/login',
//   },
// ];
const portfolioItems = [
    {
        id: 1,
        title: "Enso Glass & Door Company",
        image: ensoGlass,
        description:
            "Business suite for premium glass and door makers: e-commerce, CRM, inventory.",
        details: `
      <h3>Project Overview</h3>
      <p>An integrated business platform combining customer-facing e-commerce with back-office operations for a luxury glass and door manufacturer.</p>
      
      <h3>Key Features</h3>
      <ul>
        <li>Custom product configurator with 3D preview</li>
        <li>Augmented Reality visualization for doors/windows</li>
        <li>Inventory management with real-time tracking</li>
        <li>Lead management CRM system</li>
        <li>Measurement request scheduling</li>
        <li>Installation team dispatch system</li>
        <li>B2B/B2C multi-channel e-commerce</li>
      </ul>
      
      <h3>Technologies Used</h3>
      <div class="tech-stack">
        <span class="tech-badge">React.js</span>
        <span class="tech-badge">Node.js</span>
        <span class="tech-badge">Express</span>
        <span class="tech-badge">MongoDB</span>
        <span class="tech-badge">Redux Toolkit</span>
        <span class="tech-badge">Stripe API</span>
        <span class="tech-badge">JWT Authentication</span>
      </div>
      
      <h3>Technical Challenges</h3>
      <ul>
        <li>Developed custom WebGL renderer for product visualization</li>
        <li>Implemented AR measurement verification using device cameras</li>
        <li>Created complex inventory logic for custom manufacturing</li>
        <li>Built real-time scheduling conflict detection</li>
        <li>Optimized MongoDB aggregation pipelines for reporting</li>
      </ul>
      
      <h3>Business Impact</h3>
      <ul>
        <li>Reduced order processing time by 65%</li>
        <li>Decreased measurement errors by 80%</li>
        <li>Increased upsell conversions through visualization tools</li>
        <li>Improved inventory turnover rate by 40%</li>
      </ul>
    `,
    },
    {
        id: 2,
        title: "E-Commerce Website",
        image: commerce,
        description:
            "E-commerce with product management, cart, checkout, and secure payments.",
        details: `
      <h3>Project Overview</h3>
      <p>A complete e-commerce solution built from scratch with modern technologies.</p>
      
      <h3>Key Features</h3>
      <ul>
        <li>Product catalog with categories and filters</li>
        <li>User authentication (login/register)</li>
        <li>Shopping cart with persistent storage</li>
        <li>Checkout process with multiple payment options</li>
        <li>Admin dashboard for product management</li>
        <li>Order tracking system</li>
        <li>Product reviews and ratings</li>
      </ul>
      
      <h3>Technologies Used</h3>
      <div class="tech-stack">
        <span class="tech-badge">React</span>
        <span class="tech-badge">Node.js</span>
        <span class="tech-badge">Express</span>
        <span class="tech-badge">MongoDB</span>
        <span class="tech-badge">Redux</span>
        <span class="tech-badge">Stripe API</span>
        <span class="tech-badge">JWT</span>
      </div>
      
      <h3>Challenges Overcome</h3>
      <ul>
        <li>Implemented real-time inventory management</li>
        <li>Optimized performance for large product catalogs</li>
        <li>Created a responsive design that works on all devices</li>
      </ul>
    `,
        // link: 'https://admin.webcruxtechnology.com/login',
        // github: 'https://github.com/yourusername/ecommerce-project',
        // year: 2023,
        // client: 'Retail Client Inc.'
    },
    // {
    //   id: 2,
    //   title: 'Developer Portfolio',
    //   image: portfolio,
    //   description: 'Interactive portfolio showcasing my skills, projects, and professional journey.',
    //   details: `
    //     <h3>Project Overview</h3>
    //     <p>A personal branding website to showcase my work and attract potential clients/employers.</p>
    //     <p>Built with React, Node.js, and MongoDB. Responsive and feature-rich.</p>
    //     <h3>Key Features</h3>
    //     <ul>
    //       <li>Responsive design with dark/light mode</li>
    //       <li>Project showcase with filtering</li>
    //       <li>Interactive skills visualization</li>
    //       <li>Contact form with validation</li>
    //       <li>Blog section (optional)</li>
    //       <li>Performance optimized (95+ Lighthouse score)</li>
    //     </ul>

    //     <h3>Technologies Used</h3>
    //     <div class="tech-stack">
    //       <span class="tech-badge">React</span>
    //       <span class="tech-badge">Styled Components</span>
    //       <span class="tech-badge">Framer Motion</span>
    //       <span class="tech-badge">React Hook Form</span>
    //       <span class="tech-badge">EmailJS</span>
    //     </div>

    //     <h3>Special Touches</h3>
    //     <ul>
    //       <li>Custom animations for smooth transitions</li>
    //       <li>Accessibility-focused design</li>
    //       <li>SEO optimized structure</li>
    //       <li>Continuous deployment pipeline</li>
    //     </ul>
    //   `,
    //   link: 'https://admin.webcruxtechnology.com/login',
    //   github: 'https://github.com/yourusername/portfolio',
    //   year: 2024,
    //   client: 'Personal Project'
    // },
    {
        id: 3,
        title: "Fitness Mobile App",
        image: mobile,
        description:
            "Cross-platform fitness application with workout tracking and nutrition planning.",
        details: `
      <h3>Project Overview</h3>
      <p>A health and wellness app helping users track workouts and nutrition.</p>
      
      <h3>Key Features</h3>
      <ul>
        <li>Custom workout plan generator</li>
        <li>Exercise demonstration videos</li>
        <li>Nutrition tracking with barcode scanner</li>
        <li>Progress charts and analytics</li>
        <li>Social sharing features</li>
        <li>Push notifications</li>
      </ul>
      
      <h3>Technologies Used</h3>
      <div class="tech-stack">
        <span class="tech-badge">Flutter</span>
        <span class="tech-badge">Dart</span>
        <span class="tech-badge">Firebase</span>
        <span class="tech-badge">BLoC Pattern</span>
        <span class="tech-badge">HealthKit API</span>
        <span class="tech-badge">Google Fit API</span>
      </div>
      
      <h3>Development Highlights</h3>
      <ul>
        <li>Single codebase for iOS and Android</li>
        <li>Complex state management implementation</li>
        <li>Integration with health device APIs</li>
        <li>Optimized for offline functionality</li>
      </ul>
    `,
        // link: 'https://admin.webcruxtechnology.com/login',
        // github: 'https://github.com/yourusername/fitness-app',
        // year: 2023,
        // client: 'HealthPlus Fitness'
    },
    {
        id: 4,
        title: "HR Management System",
        image: hrManagement, // Make sure to import the image
        description: "Comprehensive HR platform for employee management, and performance tracking.",
        details: `
            <h3>Project Overview</h3>
            <p>An all-in-one HR solution automating human resource processes for mid-to-large enterprises.</p>
            
            <h3>Key Features</h3>
            <ul>
                <li>Employee onboarding workflows</li>
                <li>Time and attendance tracking</li>
                <li>Payroll processing with tax calculations</li>
                <li>Performance review system</li>
                <li>Leave management and approvals</li>
                <li>Document management (contracts, certifications)</li>
                <li>Reporting and analytics dashboard</li>
            </ul>
            
            <h3>Technologies Used</h3>
            <div class="tech-stack">
                <span class="tech-badge">React.js</span>
                <span class="tech-badge">Spring Boot</span>
                <span class="tech-badge">PostgreSQL</span>
                <span class="tech-badge">Redux</span>
                <span class="tech-badge">OAuth 2.0</span>
                <span class="tech-badge">Docker</span>
                <span class="tech-badge">AWS</span>
            </div>
            
            <h3>Technical Challenges</h3>
            <ul>
                <li>Implemented role-based access control with granular permissions</li>
                <li>Developed complex payroll calculation engine</li>
                <li>Created automated document generation system</li>
                <li>Ensured GDPR compliance for employee data</li>
            </ul>
            
            <h3>Business Impact</h3>
            <ul>
                <li>Reduced HR administrative workload by 70%</li>
                <li>Improved payroll processing accuracy to 99.9%</li>
                <li>Decreased onboarding time from 2 weeks to 3 days</li>
            </ul>
        `,
        techStack: ["React.js", "Spring Boot", "PostgreSQL", "Redux", "OAuth 2.0", "Docker", "AWS"]
    },
    {
        id: 5,
        title: "Real Estate Platform",
        image: realEstate, // Make sure to import the image
        description: "Advanced listings with virtual tours and AI-powered recommendations.",
        details: `
            <h3>Project Overview</h3>
            <p>A modern real estate marketplace connecting buyers, sellers, and agents with cutting-edge technology.</p>
            
            <h3>Key Features</h3>
            <ul>
                <li>Interactive property listings with 360° virtual tours</li>
                <li>AI-powered property recommendations</li>
                <li>Mortgage calculator and affordability tools</li>
                <li>Agent CRM and lead management</li>
                <li>Neighborhood analytics and school district data</li>
                <li>Mobile app for property viewings</li>
                <li>Document e-signing for offers/contracts</li>
            </ul>
            
            <h3>Technologies Used</h3>
            <div class="tech-stack">
                <span class="tech-badge">Next.js</span>
                <span class="tech-badge">Node.js</span>
                <span class="tech-badge">MongoDB</span>
                <span class="tech-badge">TensorFlow.js</span>
                <span class="tech-badge">WebGL</span>
                <span class="tech-badge">Google Maps API</span>
                <span class="tech-badge">Twilio</span>
            </div>
            
            <h3>Development Highlights</h3>
            <ul>
                <li>Built custom virtual tour renderer using Matterport API</li>
                <li>Developed machine learning recommendation engine</li>
                <li>Implemented real-time chat between buyers/agents</li>
                <li>Optimized for high-resolution property images</li>
            </ul>
            
            <h3>Market Impact</h3>
            <ul>
                <li>Increased agent lead conversion by 45%</li>
                <li>Reduced average time-on-market for listings by 30%</li>
                <li>Grew to 50,000+ monthly active users</li>
            </ul>
        `,
        techStack: ["Next.js", "Node.js", "MongoDB", "TensorFlow.js", "WebGL", "Google Maps API", "Twilio"]
    },
    {
        id: 6,
        title: "Inventory Management",
        image: inventorySystem, // Make sure to import the image
        description: "Enterprise inventory control with IoT integration and predictive analytics.",
        details: `
            <h3>Project Overview</h3>
            <p>A robust inventory management solution for manufacturing and retail with real-time tracking.</p>
            
            <h3>Key Features</h3>
            <ul>
                <li>Multi-location inventory tracking</li>
                <li>Barcode/RFID scanning integration</li>
                <li>Automated reorder point calculations</li>
                <li>Supplier management portal</li>
                <li>IoT device integration for warehouse monitoring</li>
                <li>Predictive inventory analytics</li>
                <li>Mobile app for stock management</li>
            </ul>
            
            <h3>Technologies Used</h3>
            <div class="tech-stack">
                <span class="tech-badge">Angular</span>
                <span class="tech-badge">.NET Core</span>
                <span class="tech-badge">SQL Server</span>
                <span class="tech-badge">Azure IoT Hub</span>
                <span class="tech-badge">Power BI Embedded</span>
                <span class="tech-badge">Redis</span>
                <span class="tech-badge">RabbitMQ</span>
            </div>
            
            <h3>Technical Challenges</h3>
            <ul>
                <li>Developed real-time sync across 50+ warehouse locations</li>
                <li>Integrated with 15+ different barcode scanner models</li>
                <li>Built predictive algorithms for stock forecasting</li>
                <li>Implemented mission-critical transaction integrity</li>
            </ul>
            
            <h3>Operational Impact</h3>
            <ul>
                <li>Reduced inventory carrying costs by 22%</li>
                <li>Improved inventory accuracy to 99.6%</li>
                <li>Decreased out-of-stock incidents by 75%</li>
            </ul>
        `,
        techStack: ["Angular", ".NET Core", "SQL Server", "Azure IoT Hub", "Power BI Embedded", "Redis", "RabbitMQ"]
    }
    // {
    //   id: 4,
    //   title: 'SaaS Landing Page',
    //   image: landing,
    //   description: 'High-conversion landing page for a B2B software product.',
    //   details: `
    //     <h3>Project Overview</h3>
    //     <p>A marketing-focused landing page designed to convert visitors into trial users.</p>

    //     <h3>Key Features</h3>
    //     <ul>
    //       <li>Hero section with clear value proposition</li>
    //       <li>Feature highlights with icons</li>
    //       <li>Customer testimonials slider</li>
    //       <li>Pricing comparison table</li>
    //       <li>Sticky call-to-action</li>
    //       <li>Contact form with lead capture</li>
    //     </ul>

    //     <h3>Technologies Used</h3>
    //     <div class="tech-stack">
    //       <span class="tech-badge">HTML5</span>
    //       <span class="tech-badge">CSS3</span>
    //       <span class="tech-badge">JavaScript</span>
    //       <span class="tech-badge">GSAP</span>
    //       <span class="tech-badge">Netlify Forms</span>
    //     </div>

    //     <h3>Performance Results</h3>
    //     <ul>
    //       <li>22% increase in conversion rate</li>
    //       <li>98/100 Google PageSpeed score</li>
    //       <li>Fully responsive across all devices</li>
    //       <li>Integrated with marketing automation tools</li>
    //     </ul>
    //   `,
    //   link: 'https://admin.webcruxtechnology.com/login',
    //   github: 'https://github.com/yourusername/saas-landing',
    //   year: 2024,
    //   client: 'CloudSolutions Inc.'
    // },
    // {
    //   id: 5,
    //   title: 'Task Management System',
    //   image: taskManagement,
    //   description: 'Collaborative project management tool for remote teams.',
    //   details: `
    //     <h3>Project Overview</h3>
    //     <p>A Kanban-style productivity app with real-time collaboration features.</p>

    //     <h3>Key Features</h3>
    //     <ul>
    //       <li>Drag-and-drop task boards</li>
    //       <li>Team member assignment</li>
    //       <li>Due date tracking</li>
    //       <li>File attachments</li>
    //       <li>Real-time updates</li>
    //       <li>Project analytics</li>
    //     </ul>

    //     <h3>Technologies Used</h3>
    //     <div class="tech-stack">
    //       <span class="tech-badge">Vue.js</span>
    //       <span class="tech-badge">Firebase</span>
    //       <span class="tech-badge">Vuex</span>
    //       <span class="tech-badge">WebSockets</span>
    //       <span class="tech-badge">Quasar Framework</span>
    //     </div>

    //     <h3>Technical Challenges</h3>
    //     <ul>
    //       <li>Implemented conflict resolution for concurrent edits</li>
    //       <li>Optimized real-time sync performance</li>
    //       <li>Developed granular permission system</li>
    //       <li>Created comprehensive activity logging</li>
    //     </ul>
    //   `,
    //   link: 'https://admin.webcruxtechnology.com/login',
    //   github: 'https://github.com/yourusername/task-manager',
    //   year: 2023,
    //   client: 'Digital Agency XYZ'
    // }
];
const Portfolio = () => {
    const navigate = useNavigate();

    // const handleCardClick = (item) => {
    //   navigate('/PortfolioDetails', { state: { item } });
    // };

    return (
        <section className="portfolio" id="portfolio">
            <div className="container">
                <div className="portfolio-section">
                    <h2 className="section-title">Our Portfolio</h2>
                </div>
                <div className="portfolio-grid">
                    {portfolioItems.map((item, index) => (
                        <div
                            className="portfolio-card"
                            key={index}
                            // onClick={() => handleCardClick(item)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="portfolio-image">
                                <img src={item.image} alt={item.title} />
                            </div>
                            <div className="portfolio-content">
                                <h3 class="project-title">{item.title}</h3>
                                <p>{item.description}</p>
                                <button
                                    className="portfolio-view-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate("/project-details", {
                                            state: { item },
                                        });
                                    }}
                                >
                                    View Details
                                    {/* <span className="btn-arrow">→</span> */}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
